
/* eslint-disable @typescript-eslint/camelcase */
import { Options, prop, Vue } from "vue-class-component";
import removeNewLineWhitespace from "@/app/infrastructures/misc/common-library/RemoveNewLineWhitespace";
import { FlagsMedusa } from "@/feature-flags/flags-misc-medusa";
import SelectPhoneCountryV2 from "../../create-booking-v2/components/select-phone-country-v2.vue";
import Checkbox from "primevue/checkbox";
import { ValidateInputPhoneNumber } from "@/app/infrastructures/misc/common-library/ValidateInputPhoneNumber";
import EditCustomerForm from "../../create-booking-v2/components/edit-customer/edit-customer-form.vue";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { BookingController } from "@/app/ui/controllers/BookingController";
import { LocationController } from "@/app/ui/controllers/LocationController";
import debounce from "lodash/debounce";
import { codePhoneCountry } from "@/app/ui/views/shipment/booking/booking-utils";
import { ShipmentBookingController } from "@/app/ui/controllers/ShipmentBookingController";
import SelectCustomerV2 from "@/app/ui/views/shipment/booking/create-booking-v2/components/select-customer-v2.vue";
import WarningSttCod from "@/app/ui/views/shipment/booking/component/error-message/warning-stt-cod.vue";
import { FlagsPermissionBooking } from "@/feature-flags/flag-booking";
import { ShipmentBookingDetail } from "@/domain/entities/ShipmentBooking";

class Props {
  modelValue = prop<any>({
    required: true,
  });
  accountIsNonForeign = prop<boolean>({
    default: false,
    type: Boolean,
  });

  disableSaveReceiver = prop<boolean>({
    default: false,
    type: Boolean,
  });

  error = prop<any>({
    required: true,
  });

  errorMessageName = prop<string>({
    required: true,
  });

  errorMessageAddress = prop<string>({
    required: true,
  });

  errorMessageDestinationCity = prop<string>({
    required: true,
  });

  isClientDO = prop<boolean>({
    default: false,
    type: Boolean,
  });

  isDO = prop<boolean>({
    default: false,
    type: Boolean,
  });

  listKGs = prop<any>({
    default: [],
    type: Array,
  });

  showErrorDistrict = prop<boolean>({
    default: false,
    type: Boolean,
  });

  currentFieldIndex = prop<number>({
    required: true,
  });

  postalCodeDestinationOptions = prop<any>({
    required: true,
  });

  allowShowZipCode = prop<boolean>({
    default: false,
    type: Boolean,
  });

  isDisableDeliveryReceiver = prop<boolean>({
    default: false,
    type: Boolean,
  });
  existCustomerReceiver = prop<any>({
    default: {existReceiver: false}
  })
  deliveryFeeType = prop<string>({
    type: String,
    default: "non-cod"
  });
  form = prop<ShipmentBookingDetail>({
    type: ShipmentBookingDetail,
    default: new ShipmentBookingDetail()
  });
  disabledPhone = prop<boolean>({
    type: Boolean,
    default: false
  });
}

@Options({
  emits: ["setFieldIndex", "onChangeDistrict", "onSearchZipCode", "onSelectAddressType", "onFocusedText", "checkFocus"],
  components: {
    WarningSttCod,
    SelectPhoneCountryV2,
    Checkbox,
    EditCustomerForm,
    SelectCustomerV2
  },
})
export default class SectionRecipientDetail extends Vue.with(Props) {
  isOpenUpload = false;
  isShowErrorAddress = false;
  originCityList: Array<any> = [];
  isDisablePostalCode = false;

  phoneNumberError = {
    success: false,
    error: false,
    message: "",
  };

  checkFocus() {
    this.$emit("checkFocus");
  }

  selectedCustomer: any = {
    customerAddress: "",
    customerId: 0,
    customerName: "",
    customerPhoneNumber: "",
    customerDistrictId: 0,
    customerDistrictName: "",
    customerZipCode: "",
    customerAddressType: "",
  };

  errorMessageAddressLocal = "";
  errorMessageNameLocal = "";

  errorEmbargo = {
    originCity: false,
    destinationCity: false,
    productType: false,
    comodity: false,
    weightStatus: false,
    lengthStatus: false,
  };

  mounted(): void {
    this.modelValue.sttRecipientPhoneCode = this.accountIsNonForeign
      ? "+62"
      : "+60";
    this.modelValue.sttRecipientPhoneFlag = this.accountIsNonForeign
      ? "indonesia"
      : "malaysia";
    this.onFocusDestinationCity();
    this.initialAddressType = this.modelValue.sttRecipientAddressType;
    this.isDisablePostalCode = this.modelValue.postalCodeDestination;
  }

  get maxAddressLength() {
    return FlagsMedusa.config_max_address.getValue();
  }

  get modelValueProps() {
    return this.modelValue;
  }

  // FUNCTIONS

  showForm() {
    this.isOpenUpload = true;
  }

  onSaveCustomer = debounce((event: any) => {
    if (!event.target.checked) {
      return;
    }
    if (
      this.modelValueProps.receiver &&
      this.modelValueProps.sttRecipientPhone &&
      this.modelValueProps.sttRecipientPhoneCode
    ) {
      BookingController.addCustomer({
        name:
          typeof this.modelValueProps.receiver === "object"
            ? this.modelValueProps.receiver.customerName
            : this.modelValueProps.receiver,
        phone: `${this.modelValueProps.sttRecipientPhoneCode.substring(1)}${
          this.modelValueProps.sttRecipientPhone
        }`,
        address: this.modelValueProps.sttRecipientAddress,
      });
    }
  }, 1000);

  validateReceiverName(value: string) {
    const min3Chars = value.length < 3;
    const empty = value === "";
    this.errorMessageNameLocal = "";
    if (min3Chars) {
      this.errorMessageNameLocal = "Nama penerima minimum 3 karakter.";
    }
    if (empty) {
      this.errorMessageNameLocal = "Nama penerima wajib diisi.";
    }
    const recieverError = min3Chars || empty;
    this.error.receiver = recieverError;
    this.$emit("update:error", { ...this.error, receiver: recieverError });
    if (!recieverError) {
      this.checkFocus();
    }
  }

  validateAddressRecipient(value: string) {
    const min3Chars = value.length < 3;
    const empty = value === "";
    this.errorMessageAddressLocal = "";
    if (min3Chars) {
      this.errorMessageAddressLocal = "Alamat penerima minimum 3 karakter.";
    }
    if (empty) {
      this.errorMessageAddressLocal = "Alamat penerima wajib diisi.";
    }
    const recieverError = min3Chars || empty;
    this.error.addressReceiver = recieverError;
    this.$emit("update:error", {
      ...this.error,
      addressReceiver: recieverError,
    });
    if (!recieverError) {
      this.checkFocus();
    }
  }

  replaceNewLine(value: string) {
    const removedNewLineAddress = removeNewLineWhitespace(value, " ");
    this.modelValue.sttRecipientAddress = removedNewLineAddress;
    this.$emit("update:modelValue", { ...this.modelValue });
    return removedNewLineAddress;
  }

  setPhoneReceiver(val: string, code = "") {
    let selectedPhoneCode = "";
    if (
      this.modelValue.sttRecipientPhoneCode !== null &&
      this.modelValue.sttRecipientPhoneCode !== ""
    ) {
      selectedPhoneCode = this.modelValue.sttRecipientPhoneCode.substring(1);
    }
    const phoneNumberWithCode = `${selectedPhoneCode}${val}`;
    this.phoneNumberError = ValidateInputPhoneNumber(phoneNumberWithCode);
    this.setErrorPhoneCodeReceiver(this.phoneNumberError.error);
    this.modelValue.sttRecipientPhone = val;
    ShipmentBookingController.setReceiverPhoneToEdit(val);
    this.$emit("update:modelValue", { ...this.modelValue });
    this.fetchCustomer(val, code);
  }

  setPhoneCodeReceiver(val: string) {
    this.modelValue.sttRecipientPhoneCode = val;
    ShipmentBookingController.setReceiverPhoneCodeToEdit(val);
    this.$emit("update:modelValue", { ...this.modelValue });
  }

  setPhoneFlagReceiver(val: string) {
    ShipmentBookingController.setReceiverPhoneFlagToEdit(val);
  }

  setErrorPhoneCodeReceiver(status: boolean) {
    this.error.sttRecipientPhoneCode = status;
    this.$emit("update:error", {
      ...this.error,
      sttRecipientPhoneCode: status,
    });
  }

  get isShipperAndConsigneeAddressIdentical() {
    if (
      this.modelValue.sttSenderAddress === "" ||
      this.modelValue.sttRecipientAddress === ""
    ) {
      return false;
    }
    return (
      String(this.modelValue.sttSenderAddress).toLowerCase() ===
      String(this.modelValue.sttRecipientAddress).toLowerCase()
    );
  }

  get getAccount(): any {
    return {
      accountType: AccountController.accountData.account_type,
      cityCode: AccountController.accountData.account_type_detail
        .partnerLocation
        ? AccountController.accountData.account_type_detail.partnerLocation
            .city_code
        : "",
      accountClientId: AccountController.accountData.account_type_detail.id
        ? AccountController.accountData.account_type_detail.id
        : "",
      isCodBooking:
        AccountController.accountData.account_type_detail.partnerIsCodBooking,
      accountTypeDetail: AccountController.accountData.account_type_detail,
    };
  }

  filterDistrict(response: any) {
    return response
      .filter((key: any) => key.status.toLowerCase() === "active")
      .map((e: any) => ({
        id: e.id,
        name: `${e.name}, ${e.cityName}`,
        code: `${e.code}`,
        cityCode: `${e.cityCode}`,
        status: e.status,
        type: e.type,
        "vendor_code": e.vendorCode,
        isCod: e.isCod,
        isFtz: e.isFtz,
        originZipCode: e.originZipCode,
      }));
  }

  onChooseReceivers(item: any, isChoosen = true) {
    if (!item) {
      return false;
    }
    this.fetchDistrictId(item.customerDistrictId).then((res: any) => {
      item = {
        ...item,
        customerPhoneCode: codePhoneCountry(item.customerPhoneNumber).code,
        customerPhoneNumber: codePhoneCountry(item.customerPhoneNumber).number,
        customerDistrictId: item.customerDistrictId > 0 ? res : "",
        customerAddressType: this.mapAddressType(item.customerAddressType),
      };

      BookingController.setDataReceiver(item);
      this.isShowErrorAddress = true;
    });

    this.modelValue.sttRecipientName = item.customerName;
    this.modelValue.sttRecipientAddress = item.customerAddress;
    this.modelValue.sttRecipientPhone = codePhoneCountry(
      item.customerPhoneNumber
    ).number;
    this.modelValue.sttRecipientAddressType = this.mapAddressType(
      item.customerAddressType
    );
    this.$emit("update:modelValue", {
      ...this.modelValue
    });

    this.error.phoneCharMinimalReceiver =
      item.customerPhoneNumber.length < 5 && isChoosen;

    // if (!isChoosen) {
      this.clearError();
    // }

    this.validatePhoneRecipient(item.customerPhoneNumber);
    this.validateReceiverName(this.modelValue.sttRecipientName);
    this.setErrorPhoneCodeReceiver(this.phoneNumberError.error);
    this.validateAddressRecipient(this.modelValue.sttRecipientAddress);
  }

  clearError() {
    this.phoneNumberError = {
      success: false,
      error: false,
      message: "",
    };
  }

  validatePhoneRecipient(value: string) {
    if (!value) {
      return;
    }
    const phoneArray = value.split("");
    if (this.detectPhoneNumber(phoneArray) && phoneArray.length > 14) {
      const newPhone = value.slice(0, -1);
      BookingController.setPhoneReceiver(newPhone);
    } else {
      BookingController.setPhoneReceiver(value);
    }
  }

  detectPhoneNumber(phoneArray: Array<string>) {
    return phoneArray.find(
      () => phoneArray[0] === "0" && phoneArray[1] === "8"
    );
  }

  setNameCustomer(search: string, type: string) {
    if (type === "senders") {
      BookingController.setNameSender(search); // set payload even if not choosing
    }
    if (type === "receivers") {
      BookingController.setNameReceiver(search); // set payload even if not choosing
    }
    if (search.length === 0) {
      return;
    }
    this.fetchCustomer(search);
  }

  fetchCustomer = debounce((search: string, code = "") => {
    if (search.length > 2) {
      BookingController.getCustomerList({
        search: code.substring(1) + search,
        cache: true,
        isSender: false
      });
    }
  }, 1000);

  get isLoadingCustomer() {
    return BookingController.isLoadingCustomer;
  }

  get receivers() {
    return this.getPhoneNumbers;
  }

  get getPhoneNumbers() {
    const list = BookingController.recipientCustomerList.data;
    if (list.length !== 0) {
      return BookingController.recipientCustomerList.data.map((item) => {
        return {
          ...item,
          customerPhoneNumber: `${item.customerPhoneNumber}`,
        };
      });
    } else {
      return list;
    }
  }

  destinationCityList: Array<any> = [];
  onFocusDestinationCity() {
    if (
      !this.destinationCityList.length ||
      !this.modelValue.sttDestinationAddress
    ) {
      LocationController.setLoadingDistrict(true);
      this.fetchDestinationCity("");
    }
    this.$emit("setFieldIndex", 10);
  }

  fetchDestinationCity = debounce(async (search: string) => {
    this.isShowErrorAddress = false;
    const typeAccuracyAllowed = true;
    const response = await LocationController.getDistrictList({
      search: search,
      status: "active",
      page: 1,
      limit: typeAccuracyAllowed ? 50 : 10,
      type:
        this.modelValue.sttReturnCod === "Yes"
          ? "within-city,forward-area"
          : "",
      cache: true,
    });
    this.destinationCityList = this.filterDistrict(response);
  }, 250);

  get isLoadingDestinationCity() {
    return LocationController.isLoadingDistrict;
  }

  get errorDestinationCity() {
    return BookingController.errorDestination;
  }

  async onChangeDistrict(val: any) {
    this.$emit("onChangeDistrict", val);
  }

  get isVendorNinjaDestination() {
    return BookingController.isVendorNinjaDestination;
  }

  setIsVendorNinjaDestination(val: boolean) {
    BookingController.setIsVendorNinjaDestination(val);
  }

  checkVendorDestinationDistrict() {
    const clientType = this.vendorTypeForDestinationDistrict;
    const vendorCode = this.vendorCodeForDestinationDistrict;

    if (clientType && vendorCode) {
      if (this.listKGs.length >= 1) {
        this.setIsVendorNinjaDestination(true);
      }
    } else {
      this.setIsVendorNinjaDestination(false);
    }

    return this.isVendorNinjaDestination;
  }

  get vendorTypeForDestinationDistrict() {
    return (
      this.modelValue.sttDestinationAddress?.type?.toLowerCase() === "vendor" ||
      this.modelValue.sttDestinationAddress?.type?.toLowerCase() ===
        "vendor_lanjutan"
    );
  }

  get vendorCodeForDestinationDistrict() {
    return (
      this.modelValue.sttDestinationAddress?.vendor_code?.toLowerCase() ===
        "ninja" ||
      this.modelValue.sttDestinationAddress?.vendor_code?.toLowerCase() === "nx" ||
      this.modelValue.sttDestinationAddress?.vendor_code?.toLowerCase() === "pi"
    );
  }

  // address type types
  get listAddressType() {
    const defaultChoices: any = [
      {
        name: this.$t("bookingShipment.column.office"),
        value: "office",
      },
      {
        name: this.$t("bookingShipment.column.home"),
        value: "home",
      },
    ];

    return defaultChoices;
  }

  get addressTypeValue() {
    return this.modelValue.sttRecipientAddressType;
  }

  isErrorSelectAddressType = false;
  initialAddressType = "";
  onSelectAddressType(name: string, value: string) {
    if (this.disableSaveReceiver && this.initialAddressType) return;
    this.$emit("onSelectAddressType");
    this.modelValue.sttRecipientAddressType = value;
    if (!value) {
      this.isErrorSelectAddressType = true;
    } else {
      this.isErrorSelectAddressType = false;
    }
  }

  setPostalCodeDestination = debounce(async (search: string) => {
    if (search) {
      this.modelValue.postalCodeDestination = {
        id: search,
        name: search
      };
      this.$emit("onFocusedText");
      ShipmentBookingController.setPostalCodeDestination({
        id: search,
        name: search
      })
    }
      const response = await LocationController.getZipCodeList({
        search: search,
        page: 1,
        limit: 10,
      });
      const zipCode = response.zipCodeData.map((item: any) => {
        return {
          id: item.id,
          name: item.originZipCode + " - " + item.name + ", " + item.cityName,
          districtName: item.name,
          cityName: item.cityName,
          status: item.status,
          code: item.code,
          cityCode: item.cityCode,
          vendorCode: item.vendorCode,
          type: item.type,
          isCod: item.isCod,
          postalCode: item.originZipCode,
          originZipCode: item.originZipCode
        };
      });

      this.$emit("onSearchZipCode", zipCode);
  }, 250);

  get _eligibleAutofillDistrict() {
    return (
      !this.modelValue.sttDestinationAddress?.originZipCode &&
      this.modelValue.postalCodeDestination
    );
  }

  onChangeZipCode(value: any) {
    if (this._eligibleAutofillDistrict || value.name?.includes("-")) {
      const disctrictName =
        this.modelValue.postalCodeDestination.districtName +
        ", " +
        this.modelValue.postalCodeDestination.cityName;
      const destinationCity = {
        id: this.modelValue.postalCodeDestination.id,
        name: disctrictName,
        status: this.modelValue.postalCodeDestination.status,
        code: this.modelValue.postalCodeDestination.code,
        cityCode: this.modelValue.postalCodeDestination.cityCode,
        vendorCode: this.modelValue.postalCodeDestination.vendorCode,
        type: this.modelValue.postalCodeDestination.type,
        isCod: this.modelValue.postalCodeDestination.isCod,
        postalCode: value.postalCode,
        originZipCode: value.originZipCode,
        vendor_code: this.modelValue.postalCodeDestination.vendorCode || this.modelValue.postalCodeDestination.vendor_code,
      };
      this.modelValue.sttDestinationAddress = destinationCity;
      this.$emit("update:modelValue", { ...this.modelValue });
      ShipmentBookingController.setSttDestinationAddress(destinationCity);
      this.onChangeDistrict(destinationCity);
      this.isShowErrorAddress = true;
    }
    this.$emit("onFocusedText");
  }

  updatePostalCode(value: any) {
    // if (value === "") {
    //   ShipmentBookingController.setSttDestinationAddress("");
    // }
  }

  async fetchDistrictId(search: number) {
    if (search) {
      const responseDistrictData = await LocationController.getDetailDistrict({
        id: search,
        notSaveDetail: true
      });
      const disctrictName =
        responseDistrictData.name + ", " + responseDistrictData.cityName;
      return {
        id: search,
        name: disctrictName,
        status: responseDistrictData.status,
        code: responseDistrictData.code,
        cityCode: responseDistrictData.cityCode,
        vendorCode: responseDistrictData.vendorCode,
        type: responseDistrictData.type,
        isCod: responseDistrictData.isCod,
        countryCode: responseDistrictData.countryCode,
        countryName: responseDistrictData.countryName,
        postalCode: responseDistrictData.originZipCode
      } as any;
    }
  }

  private mapAddressType(addressType: string): string {
    if (addressType === "rumah") {
      return "home";
    } else if (addressType === "kantor") {
      return "office";
    } else {
      return "home";
    }
  }

  editItem(item: any) {
    this.selectedCustomer = item;
    this.showForm();
  }

  get internalEditableDeliveryReceiver(): boolean {
    const prefix = FlagsPermissionBooking.adjust_recipient_prefix_stt.getValue();
    const list = prefix.split(",");
    const find = list.find(e => this.form.sttNo?.toUpperCase()?.startsWith(e));
    const internalBound =
      AccountController.accountData.isInternalAccount && !!find;

    if (internalBound) {
      return false;
    }

    return this.isDisableDeliveryReceiver;
  }

  get disbaleConditionForPosCode() {
    return this.isDisablePostalCode ? this.isDisableDeliveryReceiver : false;
  }
}
